export const getMaskedText = (textLength: number) => {
  return '•'.repeat(textLength)
}
